module.exports = __webpack_public_path__ + "static/media/dreamerhug-1.e20546ca.jpg";